import type { Chain } from 'viem'
import { getDefaultNodeUrl, getNodeUrl } from './getRpcUrl'

export const getChainWithCustomRpcUrls = (chain: Chain): Chain => ({
  ...chain,
  rpcUrls: {
    ...chain.rpcUrls,
    public: { http: [getNodeUrl(chain.id)] },
    default: { http: [getDefaultNodeUrl(chain.id)] },
  },
})
